import { defineComponent } from 'vue';
import { mapState } from 'vuex';

import { INameValue } from '@/types/common';
import { ITableOptions } from '@/bundles/BaseTable/interfaces';
import { getTableOptions } from '@/bundles/BaseTable/helpers/consts';

interface IRecordsCardMixinData {
  items: any[];
  tableOptions: ITableOptions;
  showCreateDialog: boolean;
  loading: boolean;
  filterLoading: boolean;
  total: number;
  params: INameValue<any>[];
  isApiError: boolean;
}

export const RecordsCardMixin = defineComponent({
  name: 'RecordsCardMixin',

  props: {
    allowAdd: Boolean,
    sourceType: {
      type: String,
      required: true,
    },
    sourceId: {
      type: String,
      required: true,
    },
  },

  data: (): IRecordsCardMixinData => ({
    items: [],
    tableOptions: getTableOptions({ itemsPerPage: 10 }),
    showCreateDialog: false,
    loading: true,
    filterLoading: false,
    total: 0,
    params: [],
    isApiError: false,
  }),

  computed: {
    ...mapState({
      token: (state: any) => state.idToken
    }),
    pageOffset: function (): number {
      return (this.tableOptions.page - 1) * this.tableOptions.itemsPerPage;
    },
  },

  methods: {
    toggleCreateDialog (value: boolean) {
      this.showCreateDialog = value;
    }
  }
});
